import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';

export const get =
  (config: ApiConfig) =>
  (data: Record<string, any>): Promise<Record<string, any>[]> =>
    fetchWrapper<Record<string, any>[]>(
      `${config.endpoint}logs`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      config
    );
